import { useState } from 'react';
import PropTypes from 'prop-types';
import { InputControlled } from 'components/UI/InputControlled/InputControlled';
import { ReactComponent as HelpIcon } from 'assets/icons/svgs/icon-help.svg';
import useWindowDimensions from 'hooks/use-window-dimensions';
import './RegistrationFormSections.scss';

export const LoginInformation = (props) => {
  const { errors } = props;
  const [openPopup, setOpenPopup] = useState(false);
  const { isMobile } = useWindowDimensions();
  const popupHintClass = isMobile ? 'hint-visible-m' : 'hint-visible-d';

  const showPopupHandler = (inputId) => {
    if (!isMobile) {
      setOpenPopup(inputId);
    }
  };

  const showPopupMobileHandler = (inputId) => {
    setOpenPopup((prevState) => (prevState ? false : inputId));
  };

  const renderPasswordHintButton = (inputId) => (
    <button
      type="button"
      className="hint-btn visible-xs"
      onClick={() => showPopupMobileHandler(inputId)}
    >
      <HelpIcon className="registration-form__help-icon" />
    </button>
  );

  return (
    <div className="form-section">
      <h2 className="h4">Login information</h2>

      <div className="form-group">
        <InputControlled type="email" id="regInputEmail" labelText="Email address" />
      </div>

      <div className="form-group has-hint">
        <InputControlled
          type="password"
          id="regInputPassword"
          labelText="Password"
          showPopupHandler={showPopupHandler}
        />

        {renderPasswordHintButton('regInputPassword')}

        <div className={`form-hint ${openPopup === 'regInputPassword' ? popupHintClass : ''}`}>
          <p>
            Password should be <strong>6 or more characters</strong> and contain:
          </p>
          <p>
            - English upper OR lower case letters (A to Z); <strong>and</strong>
          </p>
          <p>- At least one number (0 to 9) or character (such as !, $, #, %)</p>
          <p>
            <strong>But please don't:</strong>
          </p>
          <p>- Use your account login details or name in the password</p>
        </div>
      </div>

      <div className="form-group has-hint">
        <InputControlled
          type="password"
          id="regConfirmPassword"
          labelText="Confirm password"
          hideErrors
          showPopupHandler={showPopupHandler}
        />

        {/* For password confirmation,show both errors instead of showing only the first error */}
        {errors?.regConfirmPassword?.types?.min && (
          <p className="error-message">Password must be at least six characters long</p>
        )}
        {errors?.regConfirmPassword?.types?.oneOf && (
          <p className="error-message">Passwords do not match</p>
        )}

        {renderPasswordHintButton('regConfirmPassword')}

        <div className={`form-hint ${openPopup === 'regConfirmPassword' ? popupHintClass : ''}`}>
          <p>
            Password should be <strong>6 or more characters</strong> and contain:
          </p>
          <p>
            - English upper OR lower case letters (A to Z); <strong>and</strong>
          </p>
          <p>- At least one number (0 to 9) or character (such as !, $, #, %)</p>
          <p>
            <strong>But please don't:</strong>
          </p>
          <p>- Use your account login details or name in the password</p>
        </div>
      </div>
    </div>
  );
};

LoginInformation.propTypes = {
  errors: PropTypes.object,
};
